import React from 'react';
import PropTypes from 'prop-types';

import EventCollection from '~/glm/models/gds/event-collection';
import AnalyticsStore from '~/glm/models/analytics-store';
import GuestListStore from '~/glm/models/guest-list-store';
import {
  TASK_FREE_INVITATION_SAMPLES,
  TASK_INVITATION_AND_PAPERS,
  TASK_PROPS_LOOKING_FOR_HOTELS_INFO_CARD,
} from './constants';
import TaskComponent from './task-component';

import styles from './tasks.scss';

export const Tasks = ({ analyticsStore, hasWWS }) => {
  const render_firstTask = () => {
    if (!hasWWS) {
      return (
        <TaskComponent
          className={styles.orangeTask}
          analyticsStore={analyticsStore}
          {...TASK_FREE_INVITATION_SAMPLES}
        />
      );
    }

    return (
      <TaskComponent className={styles.yellowTask} analyticsStore={analyticsStore} {...TASK_INVITATION_AND_PAPERS} />
    );
  };

  const render_secondTask = () => {
    // default: WWS & RSVP created
    return (
      <TaskComponent
        className={styles.lightBlueTask}
        analyticsStore={analyticsStore}
        {...TASK_PROPS_LOOKING_FOR_HOTELS_INFO_CARD}
      />
    );
  };

  return (
    <div className={styles.taskContainer}>
      <div className={styles.tasks}>
        {render_firstTask()}
        {render_secondTask()}
      </div>
    </div>
  );
};

Tasks.propTypes = {
  analyticsStore: PropTypes.instanceOf(AnalyticsStore).isRequired,
  guestListStore: PropTypes.instanceOf(GuestListStore).isRequired,
  gdsEvents: PropTypes.instanceOf(EventCollection).isRequired,
  hasWWS: PropTypes.bool.isRequired,
};

export default Tasks;
